module.exports = __webpack_public_path__ + "img/clear.7336c5be.svg";